<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useAccount } from 'dashboard/composables/useAccount';
import { useStore } from 'dashboard/composables/store';
import InboxesAPI from 'dashboard/api/inboxes';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const router = useRouter();
const store = useStore();
const { accountId } = useAccount();

const dialogRef = ref(null);
const phoneNumber = ref('');
const isLoading = ref(false);

const open = () => {
  phoneNumber.value = '';
  dialogRef.value?.open?.();
};

defineExpose({ open });

const submit = async () => {
  const digits = phoneNumber.value.replace(/\D/g, '');
  if (!digits || digits.length > 15) {
    useAlert(t('INBOX_MGMT.MIGRATE_TO_BAILEYS.INVALID_PHONE'));
    return;
  }
  isLoading.value = true;
  try {
    await InboxesAPI.migrateToBaileys(props.inbox.id, digits);
    // Re-busca as inboxes para o store refletir o novo channel (Baileys) antes
    // de redirecionar - senão a aba "whatsapp-session" não aparece (Settings.vue
    // lê a inbox do store) e a tela de QR não é exibida.
    await store.dispatch('inboxes/get');
    useAlert(t('INBOX_MGMT.MIGRATE_TO_BAILEYS.SUCCESS'));
    router.push(
      `/app/accounts/${accountId.value}/settings/inboxes/${props.inbox.id}/whatsapp-session`
    );
  } catch (error) {
    useAlert(
      error?.response?.data?.message || t('INBOX_MGMT.MIGRATE_TO_BAILEYS.ERROR')
    );
  } finally {
    isLoading.value = false;
  }
};
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="
      $t('INBOX_MGMT.MIGRATE_TO_BAILEYS.TITLE', { inboxName: inbox.name })
    "
    :description="$t('INBOX_MGMT.MIGRATE_TO_BAILEYS.DESCRIPTION')"
    :confirm-button-label="$t('INBOX_MGMT.MIGRATE_TO_BAILEYS.CONFIRM')"
    :is-loading="isLoading"
    @confirm="submit"
  >
    <label class="flex flex-col gap-1 text-sm font-medium text-n-slate-12">
      {{ $t('INBOX_MGMT.MIGRATE_TO_BAILEYS.PHONE_LABEL') }}
      <input
        v-model="phoneNumber"
        type="text"
        :placeholder="$t('INBOX_MGMT.MIGRATE_TO_BAILEYS.PHONE_PLACEHOLDER')"
        class="mt-1 w-full rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2 text-sm font-normal text-n-slate-12 placeholder:text-n-slate-9 focus:outline-none focus:ring-2 focus:ring-n-brand"
      />
    </label>
  </Dialog>
</template>
